'use client';

import { useState } from 'react';

import { CallToAction } from '@/app/_componentsv2/call-to-action';
import { ApiSummaryProject } from '@/lib/core-api/types';

import { smallProjectGrid, smallProjectGridCallout } from './index.css';
import { SmallProjectCard } from './small-project-card';

export function SmallProjectGrid(props: { projects: ApiSummaryProject[] }) {
  const { projects } = props;

  const [loaded, setLoaded] = useState(9);

  return (
    <>
      <section className={smallProjectGrid}>
        {projects.slice(0, loaded).map((project) => (
          <SmallProjectCard key={project.slug} project={project} />
        ))}
      </section>
      {loaded < projects.length && (
        <section className={smallProjectGridCallout}>
          <CallToAction
            type={'button'}
            label="voir plus"
            onClick={() => setLoaded((current) => current + 9)}
          />
        </section>
      )}
    </>
  );
}
